<script>
import {mapActions} from "vuex";
import inIframe from "@/helpers/inIframe";

export default {
  mounted() {
    let token = this.$route.query.token;
    if (token) {
      this.$store.state.access_token = token;
      if (!inIframe())
        localStorage.setItem('access_token', token);
      this.getProfile();
    }

    this.$router.push('/');
  },
  methods: {
    ...mapActions({
      getProfile: 'GET_PROFILE',
    })
  }
}
</script>